import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { RegistrationPdf } from 'components';
import { routes } from 'router';
import { appService } from 'services';
import { resetSteps } from 'store';

const ConfirmationStep = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  // confirmation-other step is visible if subscription payment method is cash or cheque
  const isConfirmationOther = searchParams.get('step') === 'confirmation-other';
  const translationKey = isConfirmationOther
    ? 'auth:registration.steps.confirmationOther'
    : 'auth:registration.steps.confirmation';

  const redirectToHome = () => {
    navigate(routes.home.path, { replace: true });
    dispatch(resetSteps());
  };

  return (
    <div className="text-gray-600">
      <p className="mb-6" data-test-id="confirmationTitle">
        {t('auth:registration.steps.confirmation.welcome')}
      </p>
      {appService.isTouloisirs() ? (
        <>
          <Trans i18nKey={`${translationKey}.content`}>
            <span className="text-primary-500">{t('auth:registration.steps.confirmation.email')}</span>
          </Trans>

          <p className="my-6">
            <Trans i18nKey={`${translationKey}.${isConfirmationOther ? 'address' : 'login'}`}>
              <br />
              <br />
            </Trans>
          </p>
          <p className={clsx('mb-6', !isConfirmationOther ? 'text-gray-500' : 'text-gray-600')}>
            <Trans i18nKey={`${translationKey}.warning`}>
              <br />
            </Trans>
          </p>
        </>
      ) : (
        <>
          <Trans i18nKey={'auth:registration.steps.confirmation.contentArrivaj'}>
            <span className="text-primary-500"></span>
          </Trans>

          <p className="my-6">
            <Trans
              i18nKey={'auth:registration.steps.confirmation.loginArrivaj'}
              values={{ subdomain: appService.getCSE() }}
            ></Trans>
          </p>
        </>
      )}

      {isConfirmationOther ? (
        <RegistrationPdf />
      ) : (
        <button type="button" className="btn uppercase w-fit mx-auto" onClick={redirectToHome}>
          {t('buttons.goBackHome')}
        </button>
      )}
    </div>
  );
};

export default ConfirmationStep;
